export default __webpack_public_path__ + "static/media/vege.9f540346.jpg";